module.exports = __webpack_public_path__ + "img/00vacature_graphic-05.4c89d4d7.png";